import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import AddCityCentre from './components/AddCityCentre';
import CandidateManagement from './components/CandidateManagement';
import Header from './components/Header';
import UploadResume from './components/UploadResume';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Login from './components/Login';
import AddUser from './components/AddUser';
import AddVacancy from './components/AddVacancy';
import ViewVacancies from './components/ViewVacancies';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Protected Route component with role checking
const ProtectedRoute = ({ children, requiredRole = null }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userRole = localStorage.getItem('role');

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/" />;  // Redirect to home if user doesn't have required role
  }

  return children;
};

function App() {
  return (
    
    <Router>
      <ToastContainer position="top-right" />
      <div className="flex flex-col min-h-screen">
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <>
                  <Header />
                  <div className="main-content flex-grow">
                    <HomePage />
                  </div>
                  <Footer />
                </>
              </ProtectedRoute>
            }
          />

          <Route
            path="/candidate-management"
            element={
              <ProtectedRoute>
                <>
                  <Header />
                  <div className="main-content flex-grow">
                    <CandidateManagement />
                  </div>
                  <Footer />
                </>
              </ProtectedRoute>
            }
          />

          <Route
            path="/upload-resume"
            element={
              <ProtectedRoute>
                <>
                  <Header />
                  <div className="main-content flex-grow">
                    <UploadResume />
                  </div>
                  <Footer />
                </>
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute requiredRole="superadmin">
                <>
                  <Header />
                  <div className="main-content flex-grow">
                    <AddCityCentre />
                  </div>
                  <Footer />
                </>
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-user"
            element={
              <ProtectedRoute requiredRole="superadmin">
                <>
                   <Header />
                  <div className="main-content flex-grow">
                    <AddUser />
                  </div>
                  <Footer />
                </>
              </ProtectedRoute>
            }
          />

<Route
  path="/add-vacancy"
  element={
    <ProtectedRoute requiredRole="superadmin">
      <>
        <Header />
        <div className="main-content flex-grow">
          <AddVacancy />
        </div>
        <Footer />
      </>
    </ProtectedRoute>
  }
/>

<Route
  path="/vacancies"
  element={
    <ProtectedRoute>
      <>
        <Header />
        <div className="main-content flex-grow">
          <ViewVacancies/>
        </div>
        <Footer />
      </>
    </ProtectedRoute>
  }
/>
        </Routes>


      </div>
    </Router>
  );
}

export default App;